import { useEffect, useState } from 'react';

// Service
import CashRegisterService from '../../services/cashRegisterService';
import { movementTypesFormat, subTypesFormat, cashTypesFormat } from '../../models/CashRegisterMovementEntity';

//Hooks
import useUser from "../user/useUser";
import useQueryString from '../queryString/useQueryString';

const initialState = {
    items: [],
    totalResults: 0,
    totalPage: 1,
    filters: {
        cashRegisterId: 0,
        reason: '',
        from: '',
        to: '',
        cashType: '',
        pageSize: 10,
        pageNumber: 1,
    }
}

const useCashRegisterImprestMovements = () => {
    const { branch } = useUser();
    const { filters, setParameterSearch, clearFilters } = useQueryString({ ...initialState.filters, });
    const [loading, setLoading] = useState(false);
    const [cashRegisterState, setCashRegisterState] = useState(initialState);
    const [cashRegisterId, setCashRegisterId] = useState(null);

    const mapCashRegisterMovements = (items) => {
        return items && items.map(i => ({
            ...i,
            typeFormat: movementTypesFormat[i.type] || i.type,
            subTypeFormat: subTypesFormat[i.subType] || i.subType,
            cashTypeFormat: cashTypesFormat[i.cashType] || i.cashType,
        }));
    }

    useEffect(() => {
        const SearchCashRegisterMovements = async () => {
            setLoading(true);
            await CashRegisterService
                .SearchMovements(filters?.pageSize, filters?.pageNumber, { ...filters, cashRegisterId }, branch?.id)
                .then(res =>
                    setCashRegisterState(state => ({
                        ...state,
                        items: mapCashRegisterMovements(res.values),
                        totalResults: res.totalResults,
                        totalPage: res.totalPage
                    })))
                .finally(() => setLoading(false));
        }
        if (filters !== null && !!branch.id && cashRegisterId && cashRegisterId !== 0) {
            SearchCashRegisterMovements();
        }
    }, [filters, cashRegisterId, branch.id]);

    return {
        cashRegisterMovements: cashRegisterState.items,
        totalPage: cashRegisterState.totalPage,
        loading,
        filters,
        clearFilters,
        setParameterSearch,
        setCashRegisterId
    }
}

export default useCashRegisterImprestMovements;